<template>
  <div>
    <!-- pagination -->
    <div class="container" id="news">
      <div class="row bar">
       
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">最新消息</div>
            <div class="col bg-n-gray text-left">NEWS</div>

          </div>
        </div>
       
      </div>
       <!-- search -->
       <div class="row">
         <div class="col-12 col-xl-auto ml-auto search-parent">
          <div class="  search">
            <span class="fa fa-search"></span>
            <input placeholder="搜尋" v-model="searchName" @change="searchSend()">
          </div>
        </div>
       </div>
        
        <!-- search end -->
     

        

      <div class="row  justify-content-center" >

      <div class="col-12 data-loop" v-for="(item) in store" :key="item.id" >
       <div class="row py-3 border-dot">
         <div class="d-none d-sm-block col-sm-3 text-left" style="font-size:21px;font-weight: bold">{{item['created_date']}}</div>
         <div class="col-12 col-sm-9 text-left">
           <div class="row">
            <div class="d-block d-sm-none col-9" style="font-size:21px">{{item['created_date']}}</div>
            <!-- 丟id到url router -->
            <div class="d-block d-sm-none col-3  text-right "><router-link :to="{name:'newspage', params:{placeName:item['id']}}" class="text-danger" style="font-weight: bold">more</router-link></div>
             <div class="col-12 col-sm-9 col-lg-10"><h2 class="topic">{{item.title}}</h2></div>
             <div class="d-none d-sm-block col-3 col-lg-2 text-right "><router-link :to="{name:'newspage', params:{placeName:item['id']}}" class="text-danger" style="font-weight: bold">more</router-link></div>
             <div class="col-12"><p class="clamp-3 content">{{item['content_text']}}</p></div>
           </div>
           
           
         </div>
       </div>
       
       
        
        <p></p>

      </div>

    </div>
    <b-pagination-nav style="margin-top:75px" size="sm" :link-gen='linkGen' v-model="currentPage" :number-of-pages="numberOfPages"  align="center" 
    />
    </div>
    
  </div>
</template>


<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
export default {
  data() {
    return {
      searchName: '',
      currentPage: 1,
      store: [],
      totaldata: 0,
      numberOfPages: 10,
      newsPerPage: 6,
      a: [
        {
          xs: "/static/news/320/1.jpg",
          sm: "/static/news/320/1.jpg",
          md: "/static/news/768/1.jpg",
          lg: "/static/news/768/1.jpg",
          xl: "/static/news/1200/1.jpg"
        }
      ]
    };
  },
  watch:{
    currentPage:function(){
      console.log('change'+this.currentPage);
      this.getData();
      console.log('changed'+this.currentPage);
      this.doScroll()
    }
  },
  methods: {
    searchSend(){
     this.currentPage=1;
     this.getData();
     
    },
    doScroll(){
      // console.log('do scroll')
      document.documentElement.scrollTop = 0
    
    },
    linkGen (pageNum) {
      return '#news#'+pageNum
     
    },
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    },
    getUrl() {
      let vm = this;
      let url = document.URL;
      console.log(url);
      let sliceposition = url.lastIndexOf("#");
      console.log(sliceposition);
      let slicedata = url.slice(sliceposition + 1);
      console.log(slicedata);
      vm.currentPage = parseInt(slicedata);
      console.log("url給的" + vm.currentPage);
      vm.getData();
    },
    getData() {
      let vm = this;

      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/news/list",
        params: {
          limit: vm.newsPerPage,
          offset: vm.newsPerPage * (vm.currentPage - 1),
          search: vm.searchName
        }
      })
        .then(function(response) {
          console.log(response);

          vm.store = [];
          response.data.data.forEach(element => {
            vm.store.push(element);
          });

         


          vm.totaldata = response.data.total;
          let rest=(vm.totaldata % vm.newsPerPage);
          vm.numberOfPages = parseInt(vm.totaldata / vm.newsPerPage) ;
          if(vm.numberOfPages==0 || rest!=0) {vm.numberOfPages=vm.numberOfPages+1}

        })
    }
  },

  mounted: function() {

  },

  created: function() {
    this.pusha();
    this.getUrl();
  }
};
</script>


<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
@import url("https://use.fontawesome.com/releases/v5.0.12/css/solid.css")
@import url("https://use.fontawesome.com/releases/v5.0.12/css/fontawesome.css")
.red-div
  width: 50px
  height: 50px
  background-color: rgb(175, 40, 45)
.gray-div
  color: white
  line-height: 50px
  width: 130px
  height: 50px
  background-color: rgb(205, 205, 205)

.border-dot
  border-bottom: 1px dashed rgb(51, 58, 64)

.data-loop:nth-last-child(1)>.border-dot
  border-bottom: none
.topic
  color: rgb(51, 58, 64)
  font-weight: bold
  font-size: 21px
  margin-bottom: 20px
.content
  color: black
  font-size: 18px
  font-weight: bold
.clamp-3
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  -webkit-line-clamp: 3
  /*! autoprefixer: off */
  -webkit-box-orient: vertical
  /* autoprefixer: on */

// .bg-n-red
//   background-color: rgb(182, 40 ,44)
//   color: white
//   text-align: center
//   padding-top: 7px
//   padding-bottom: 7px
// .bg-n-gray
//   background-color: rgb(51, 58, 64)
//   color: white
//   padding-left: 13px
//   padding-top: 7px
//   padding-bottom: 7px

#news
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px

.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px
.search-parent
  @include media-breakpoint-up(xs)
    margin-top: 20px
    padding-right: 15px
  @include media-breakpoint-up(xl)
    padding-right: 15px
.search
  position: relative
  color: #aaa
  font-size: 16px
  input
    @include media-breakpoint-up(xl)
      width: 175px
    @include media-breakpoint-up(xs)
      width: 100%
    height: 40px
    background: #fcfcfc
    border: 1px solid rgb(195, 13 , 35)
    border-radius: 5px
    box-shadow: 0 0 3px #ccc, 0 10px 15px #ebebeb inset
    text-indent: 32px
  .fa-search
    position: absolute
    top: 10px
    left: 10px

</style>






// WEBPACK FOOTER //
// src/components/News.vue